import { DIVIDER } from './constants';
import { MixedMenuItems, SimpleMenuItems, UniversalCreateItems } from './types';

export function isSimpleMenuItems(items: UniversalCreateItems): items is SimpleMenuItems {
	return Array.isArray(items) && items.every((item) => !Array.isArray(item) && item !== DIVIDER);
}

export function normaliseItems(items: UniversalCreateItems): MixedMenuItems {
	if (isSimpleMenuItems(items)) {
		return [items];
	}
	return items;
}
